<script>
export default {
  props: {
    variant: {
      type: String,
      default: 'success',
    },
  },
  data() {
    return {
      dismissSecs: 5,
      dismissCountDown: 0,
    }
  },
  mounted() {
    this.showErrorAlert()
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
      if (dismissCountDown === 0) {
        this.$emit('alertDismissed', dismissCountDown)
      }
    },
    showErrorAlert() {
      this.dismissCountDown = this.dismissSecs
    },
  },
}
</script>

<template>
  <div class="alert--wrap container-fluid w-100 pt-4 mt-5 bg-transparent">
    <div class="col col-5 mx-auto">
      <b-alert
        :show="dismissCountDown"
        dismissible
        :variant="variant"
        v-bind="$attrs"
        class="p-4"
        @dismissed="dismissCountDown = 0"
        @dismiss-count-down="countDownChanged"
      >
        <slot />
      </b-alert>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>

<style scoped>
.alert--wrap {
  width: 100%;
}
</style>
